module.exports = __webpack_public_path__ + "static/media/list-items.2483e0d5.png";